import api, { chatBotApi } from 'config/api';
import { apiDecidir } from 'config/apiGateways';

export const getPrintedPaymentDocument = (clientNumber, userData = {}, externalId = null) =>
  api.post('api/v1/bills/payment_document', {
    client_number: clientNumber,
    email: userData.email,
    document_type: userData.documentType,
    document_number: userData.documentNumber,
    external_id: externalId
  });

export const getPrintedPaymentDocumentPDF = (clientNumber, externalId) =>
  api.get(
    '/api/v1/bills/payment_document_pdf',
    { client_number: clientNumber, external_id: externalId },
    { headers: { Accept: 'application/pdf' }, responseType: 'arraybuffer' }
  );

export const getMultiplePaymentDocuments = clientNumber =>
  api.get(
    '/api/v1/bills/payment_document_zip',
    { client_number: clientNumber },
    { headers: { Accept: 'application/zip' }, responseType: 'arraybuffer' }
  );

export const getPayableDocuments = (clientNumber, documentType, documentNumber, gender) => {
  const queryParameters = {};
  if (clientNumber) queryParameters.client_number = clientNumber;
  if (documentType) {
    queryParameters.document_type = documentType;
    queryParameters.document_number = documentNumber;
  }
  if (gender) queryParameters.gender = gender;
  return api.get('api/v1/bills/payable', queryParameters);
};

export const getAccountUnpaidBills = accountId => api.get(`api/v1/accounts/${accountId}/debts`);

export const getPublicAccountUnpaidBills = clientNumber =>
  api.get(`api/v1/accounts/debts`, { client_number: clientNumber });

export const getPaymentToken = (values, apikey, url) =>
  apiDecidir(apikey, url).post(null, {
    card_number: values.cardnumber,
    card_expiration_month: values.expmonth,
    card_expiration_year: values.expyear.slice(2, 4),
    security_code: values.cvm,
    card_holder_name: values.holdername,
    card_holder_identification: {
      type: values.docType,
      number: values.docNumber
    }
  });

export const paymentRequest = (paymentTokenInfo, bills, totalAmount, paymentMethod, email, requestNumber) =>
  api.post('api/v1/payments', {
    bills,
    token: paymentTokenInfo.id,
    bin: paymentTokenInfo.bin,
    last_four_digits: paymentTokenInfo.last_four_digits,
    payment_method: paymentMethod,
    email,
    total_amount: totalAmount,
    request_number: requestNumber
  });

export const getPaymentIdentifier = (gateway, clientNumber, email) =>
  api.get('api/v1/payments/identification', { gateway, client_number: clientNumber, email });

export const sendAgentTransaction = (type, transactionid, messages) =>
  chatBotApi.post('api/v1/whatsapp/message/transaction', { transactionid, action: type, message: messages });
